import React from 'react'

import { TextError } from './styles'

export function ErrorMessage({
  errorText,
  color = 'error',
  fontWeight = '300',
  marginLeft = '4px',
  marginTop = '4px',
}) {
  return (
    <TextError
      color={color}
      fontWeight={fontWeight}
      marginLeft={marginLeft}
      marginTop={marginTop}
    >
      {errorText}
    </TextError>
  )
}
